<template>
  <div class="video-border">
    <div class="video-wrapper" v-for="(item,index) in cameras" :key="index">
      <HomeViewComponentVideoMonitorControl
        class="video"
        @spread="cameraSpread"
        :cameraId="item.ItemKey"
        :cameraName="item.Extend1"
        :autoplay="false"
      />
    </div>
  </div>
</template>
<script>
import HomeViewComponentVideoMonitorControl from "./HomeViewComponentVideoMonitorControl";
import MyApis from "../../../apis";

export default {
  name: "HomeViewVideoMonitor",
  componentName: "HomeViewVideoMonitor",
  components: {
    HomeViewComponentVideoMonitorControl: HomeViewComponentVideoMonitorControl,
  },
  data() {
    return {
      cameras: []
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        SysCode: "HomeView",
        Key: "VideoMonitor",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.cameras = r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
  },
};
</script>

<style scoped>
</style>